import { Box, Heading, Stack } from '@chakra-ui/react';
import { PageContainer } from '../page-container';
import { Card } from '@ui/Card';
import { componentReference } from '../home/content';
import { Support } from '../home/support';
import { DocsTemplateContent } from '@types';

type Props = {
  content: DocsTemplateContent;
};

export function DocsComponentReference({ content }: Props): JSX.Element {
  return (
    <PageContainer>
      <Box
        py={{ base: 12, lg: 16, xl: 24 }}
        borderBottom="1px solid"
        borderColor="var(--borderColor)"
      >
        <Box maxW="container.lg" mx="auto" px={{ base: 6, lg: 10 }}>
          <Heading
            as="h1"
            color="var(--primaryTextColor)"
            size="h4"
            fontWeight="medium"
            mb={2}
          >
            {content.title}
          </Heading>
        </Box>
      </Box>

      <Stack
        spacing={12}
        py={12}
        px={{ base: 6, lg: 10 }}
        maxW="container.lg"
        mx="auto"
      >
        <div className="grid auto-rows-fr grid-cols-1 gap-6 md:grid-cols-2">
          {componentReference.map(({ title, description, url, icon }) => (
            <Card
              key={title}
              title={title}
              description={description}
              url={url}
              IconComponent={icon}
            />
          ))}
        </div>

        <Box pt={12}>
          <Support />
        </Box>
      </Stack>
    </PageContainer>
  );
}
